import React from "react";
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {

	return (
		<div className="footer">
		
			<div className="footer__name">
				<h4>Hand Me Style</h4>
			</div>
			<div className="contact">
				<div className="contact__part">
					<MailIcon fontSize="large" style={{color: "white"}} />
					<a className="contact__part-att" href="mailto:technoinfo.llc@gmail.com">technoinfo.llc@gmail.com</a>
				</div>
				<div className="contact__part">
					<PhoneIcon fontSize="large" style={{color: "white"}} />
					<a className="contact__part-att" href="tel:+1 (469) 224-0127">+1 (469) 224-0127</a>
				</div>
			</div>
			
		</div>
	);
};

export default Footer;
